import { executeOnDocumentReady } from '../../utils.js';

import checkBackMove from './js/check-back-move.js';
import initReply from './js/page-offer-reply.js';
import initPopupReply from './js/popup-offer-reply.js';
import floatButton from './js/float-button';
import phoneModal from './js/phone-modal.js';

import './style.less';
import './style.scss';

executeOnDocumentReady(() => {
	initReply();
	initPopupReply();
	floatButton();
	checkBackMove();
	phoneModal();
});
